<div class="bg-editor">
  <!-- Left: Type selector -->
  <div class="bg-panel bg-panel-left">
    <div class="bg-panel-label">Type</div>
    <div
      class="bg-type-item"
      *ngFor="let t of types"
      [class.selected]="selectedType === t.key"
      (click)="selectType(t.key)"
    >
      <nw-icon [type]="t.icon" [size]="14" color="#6b7280"></nw-icon>
      <span>{{ t.label }}</span>
    </div>
  </div>

  <!-- Center: Preview -->
  <div class="bg-panel bg-panel-center">
    <div class="bg-preview-toolbar" *ngIf="selectedType === 'image' && bgDef?.type === 'image'">
      <button
        class="toolbar-btn"
        [class.active]="showCrop"
        (click)="toggleCrop()"
        title="Edit crop"
      >
        <nw-icon type="crop" [size]="16" [color]="showCrop ? '#3b82f6' : '#6b7280'"></nw-icon>
      </button>
    </div>

    <nw-scene-preview
      *ngIf="!showCrop"
      [scene]="previewScene"
    ></nw-scene-preview>

    <nw-background-crop-preview
      *ngIf="showCrop"
      [backgroundDef]="bgDef"
      [animation]="scene?.background?.animation || {}"
      (cropChange)="onCropChange($event)"
    ></nw-background-crop-preview>
  </div>

  <!-- Right: Type-specific form -->
  <div class="bg-panel bg-panel-right">
    <!-- Image list -->
    <ng-container *ngIf="selectedType === 'image'">
      <div class="bg-panel-label">Images</div>
      <div class="image-grid">
        <div
          class="image-thumb"
          *ngFor="let img of images"
          [class.selected]="selectedImageUrl === img.url"
          (click)="selectImage(img)"
        >
          <img [src]="getImageThumbUrl(img)" [alt]="img.fileName || 'image'" loading="lazy">
        </div>
      </div>
      <div class="bg-empty" *ngIf="!images.length">No images uploaded</div>
    </ng-container>

    <!-- Glove options (placeholder) -->
    <ng-container *ngIf="selectedType === 'gloves'">
      <div class="bg-panel-label">Gloves</div>
      <div class="bg-empty">Glove settings coming soon</div>
    </ng-container>

    <!-- Gradient form -->
    <ng-container *ngIf="selectedType === 'gradient'">
      <div class="bg-panel-label">Gradient</div>
      <div class="bg-form">
        <div class="form-group">
          <div class="form-group-label">Colors</div>
          <div class="color-inputs">
            <label *ngFor="let c of gradientColors; let i = index" class="color-input">
              <input
                type="color"
                [ngModel]="c"
                (ngModelChange)="onGradientColorChange(i, $event)"
              >
              <span class="color-hex">{{ c }}</span>
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="form-group-label">Direction</div>
          <div class="direction-btns">
            <button
              class="dir-btn"
              [class.active]="gradientDirection === GradientDirection.Horizontal"
              (click)="onGradientDirectionChange(GradientDirection.Horizontal)"
            >Horizontal</button>
            <button
              class="dir-btn"
              [class.active]="gradientDirection === GradientDirection.Vertical"
              (click)="onGradientDirectionChange(GradientDirection.Vertical)"
            >Vertical</button>
            <button
              class="dir-btn"
              [class.active]="gradientDirection === GradientDirection.Diagonal"
              (click)="onGradientDirectionChange(GradientDirection.Diagonal)"
            >Diagonal</button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Solid fill form -->
    <ng-container *ngIf="selectedType === 'solid'">
      <div class="bg-panel-label">Solid Fill</div>
      <div class="bg-form">
        <div class="form-group">
          <div class="form-group-label">Color</div>
          <label class="color-input">
            <input
              type="color"
              [ngModel]="solidColor"
              (ngModelChange)="onSolidColorChange($event)"
            >
            <span class="color-hex">{{ solidColor }}</span>
          </label>
        </div>
      </div>
    </ng-container>
  </div>
</div>
